import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowRight, Error } from "@carbon/icons-react";
import { Button } from "@carbon/react";

export default function ErrorPage() {
  const location = useLocation();
  const errorData = location.state;
  const navigate = useNavigate();

  const code = errorData?.code || "404";
  const message = errorData?.message || "Oops, This Page Not Found!";

  const getActionMessage = (code, message) => {
    if (code === "200") {
      if (message === "Public name of agent not filled") {
        return "To proceed, you need to create a Public Name. Please contact your manager.";
      }
      return "An unexpected response was received. Please try again later or contact support.";
    }

    switch (code) {
      case "400":
        return "Bad request. Please check the link or try again later.";
      case "401":
        return "You are not authorized to access this page. Please log in and try again.";
      case "403":
        return "Access denied. You don’t have permission to view this page.";
      case "404":
        return "The page you’re looking for doesn’t exist. Please check the URL or go back to the homepage.";
      case "410":
        return "This link has expired or is no longer valid. Please request a new one.";
      default:
        return "Oops, something went wrong. Please reload the application and try again. If the problem persists, feel free to contact our support team.";
    }
  };

  const action = getActionMessage(code, message);

  return (
    <div style={{ padding: "32px", marginTop: "50px", textAlign: "center" }}>
      <Error color="red" size="120" />
      {code && (
        <h1 style={{ fontSize: "92px" }}>{`${code === "200" ? "400" : code}`}</h1>
      )}
      <p style={{ marginBottom: "16px", fontWeight: "600", fontSize: "20px" }}>
        {message}
      </p>
      <p>{action}</p>
      <Button
        onClick={() => navigate("/")}
        style={{ marginTop: "32px" }}
        renderIcon={ArrowRight}
      >
        Back to homepage
      </Button>
    </div>
  );
}
